import React, { useCallback, useEffect, useMemo } from "react";
import { connect } from "react-redux";

import AutomaticSystemsContainer from "./components/AutomaticSystemsContainer";
import AutomaticSystemsActioner from "services/gates/AutomaticSystems/actioner";
import ParkkiTheme from "themes/ParkkiTheme";
import styled from "@emotion/styled";

const StyledContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${ParkkiTheme.colors.lightGrey};
  margin-bottom: ${ParkkiTheme.spacings.xsmall};
  font-family: "Source Sans Pro", sans-serif;
`;

const ContentContainer = styled.main`
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px ${ParkkiTheme.spacings.tiny} 0;
`;

function AutomaticSystems({ contract, initializeModule, loading }) {
  const contractId = useMemo(() => contract?.id, [contract]);

  const initializeModuleData = useCallback(async () => {
    if (contractId) {
      await initializeModule();
    }
  }, [contractId, initializeModule]);

  useEffect(() => {
    setTimeout(initializeModuleData, 200);
  }, [initializeModuleData]);

  return (
    <StyledContainer>
      <div>
        <ContentContainer>
          <>
            <AutomaticSystemsContainer />
          </>
        </ContentContainer>
      </div>
    </StyledContainer>
  );
}

const mapStateToProps = (state) => ({
  contract: state.Contract.contract,
  loading: state.AutomaticSystems.automaticSystems.loading,
});

const mapDispatchToProps = (dispatch) => ({
  initializeModule: () =>
    dispatch(AutomaticSystemsActioner.retrieveAutomaticSystems()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AutomaticSystems);
